import React, { useRef } from 'react';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import { useElf } from '../../../../redux/reducer/elf';
import Icon from '../../../baseComponents/gui/icon/Icon';
import { safeHTML } from '../../../../utils/safeHTML';
import { customizationRoomShowAnimation } from './customizationRoomShowAnimation';
import { useTranslation } from '../../../../translations';

const CustomizationRoomsItem = React.forwardRef(function CustomizationRoomsItem(
  { id, photo, preview, title, setCustomStep, callbacks, index },
  ref,
) {
  const { activeRoom } = useElf();

  const itemRef = useRef(null);
  const itemContRef = useRef(null);
  const buttonRef = useRef(null);
  const imageRef = useRef(null);
  const titleRef = useRef(null);
  const checkRef = useRef(null);
  const { t } = useTranslation();

  const setRoom = () => {
    setCustomStep('filters');
    id !== activeRoom && callbacks.setActiveRoom(id);
  };

  customizationRoomShowAnimation({ index, itemRef, buttonRef, imageRef, titleRef, checkRef });

  return (
    <div key={`b-${id}`} className={classNames('customization__filter-box customization__rooms-box')} ref={itemRef}>
      <div className={'customization__filter-content'} ref={itemContRef}>
        <CustomButton className={'customization__filter button_filter customization__rooms-button'} onClick={setRoom}>
          {preview && (
            <div className={'button__icon button_transparent custom-button__icon'} ref={imageRef}>
              <img src={preview} alt={''} />
            </div>
          )}
          <div
            className={classNames('customization__rooms-check', {
              'customization__rooms-check_active': activeRoom === id,
            })}
            ref={checkRef}
          >
            <Icon name={'customization/check-room'} />
          </div>
          <div ref={titleRef} className={'customization__filter-title customization__rooms-title'}>
            {safeHTML(title)}
          </div>
          <div className={'customization__filter-select-wrapper'} ref={buttonRef}>
            <CustomButton
              className={'customization__rooms-select button_product button_product-unequip'}
              text={t('other.select')}
            />
          </div>
        </CustomButton>
        {/*{isNew && <span className={"customization__rooms-new"}>{newText}</span>}*/}
      </div>
    </div>
  );
});
export default CustomizationRoomsItem;
CustomizationRoomsItem.propTypes = {};
